import { Controller } from "stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  change(event) {
    const organizationId = event.target.value
    const programType = event.target.dataset.program

    get(`/accounts/${organizationId}/dashboard?program_type=${programType}`, {
      responseKind: "turbo-stream"
    })
  }
}
